import { types } from '../types/types';

const initialState = {
	isLoading: false,
	data: [],
	total: 0,
	page: 1,
	lastPage: 1,
	pageSize: 20,
	next: null,
	previous: null,
	endpoint: null,
	searchActive: false,
};

export const newSearcherReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setSearcher:
			return action.payload;

		case types.cleanSearcher:
			return initialState;

		default:
			return state;
	}
};
